import { createApiSlice } from "@common";
import {
    MY_INFO_ACCOUNT
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addMyInfoAccountDetails",
        method: "post",
        url: MY_INFO_ACCOUNT,
        stateKey: "message",
    },
    {
        name: "getMyInfoAccountDetails",
        method: "get",
        url: MY_INFO_ACCOUNT,
        stateKey: "data",
    },
    {
        name: "updateMyInfoAccountDetails",
        method: "put",
        url: MY_INFO_ACCOUNT,
        stateKey: "message",
    },
    {
        name: "deleteMyInfoAccountDetails",
        method: "delete",
        url: MY_INFO_ACCOUNT,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "MyInfoAccountDetails",
    apiConfig,
    customReducers,
);
const MyInfoAccountDetailsSlice = slice;
// Export the slice's reducer
export default MyInfoAccountDetailsSlice.reducer;





// Destructure and export thunks directly from thunksExports
export const {
    addMyInfoAccountDetails,
    getMyInfoAccountDetails,
    updateMyInfoAccountDetails,
    deleteMyInfoAccountDetails
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
